import React from 'react';
import { Button } from 'components/shadcn/ui/button';
import { LoadingSpinner } from 'components/shadcn/ui/loadingSpinner';
import { cn } from 'components/shadcn/lib/utils';

const HGFormSubmitBtn = ({ children, loading, className, ...props }) => {
    return (
        <Button
            type="submit"
            variant="outline"
            disabled={loading}
            className={cn('relative', className)}
            {...props}
        >
            {loading ? (
                <LoadingSpinner className="h-5 w-5" />
            ) : (
                <span
                    className={cn(
                        'text-sm font-medium capitalize text-foreground',
                        loading && 'opacity-0'
                    )}
                >
                    {children}
                </span>
            )}
        </Button>
    );
};

export default HGFormSubmitBtn;
